import { User } from 'modules/types/User';
import {
  StyledNotificationCountCircle,
  StyledProfileDropdown,
  StyledProfileIcon,
  StyledProfileIconContainer,
  StyledProfileItemContainer,
} from './styled';

interface ProfileItemProps {
  user: User;
  notificationCount?: number;
}

export const ProfileItem: React.FC<ProfileItemProps> = ({
  user,
  notificationCount,
}) => (
  <StyledProfileItemContainer>
    <StyledProfileIconContainer>
      <StyledProfileIcon />
      {notificationCount !== undefined && notificationCount > 0 && (
        <StyledNotificationCountCircle>
          {notificationCount}
        </StyledNotificationCountCircle>
      )}
    </StyledProfileIconContainer>
    <StyledProfileDropdown>
      {user.lastName && user.firstName
        ? `${user.lastName} ${user.firstName}`
        : user.partnerName}
    </StyledProfileDropdown>
  </StyledProfileItemContainer>
);
